<template>
    <v-text-field
        class="search-input"
        v-model="search.value"
        label="Search Part Number"
        variant="underlined"
        clearable
        @click:clear="onClearClicked"
        @update:modelValue="handleSearchUpdate"
    >
        <template #append-inner>
            <v-icon
                :style="{ opacity: '1' }"
                color="black"
                icon="mdi:mdi-magnify"
                theme="light"
                right
            />
        </template>
    </v-text-field>

    <Vue3EasyDataTable
        v-model:items-selected="selectedParts"
        :headers="headers"
        :items="parts"
        header-item-class-name="table-header"
        table-class-name="customize-table"
        :search-field="search.columns"
        :search-value="search.value"
        :table-height="600"
        :rows-items="[100, 1000, 10000]"
        :rows-per-page="1000"
        theme-color="#242939"
        ref="datatable"
        :loading="loading"
    >
        <template #loading>
            <v-progress-circular
                indeterminate
                :size="120"
            >
                <v-img
                    src="/images/d3_connect.png"
                    v-if="loading"
                    :size="10"
                    class="loading-spinner"
                    :style="{
                        marginLeft: '9px',
                    }"
                    indeterminate
                ></v-img>
            </v-progress-circular>
        </template>
    </Vue3EasyDataTable>
</template>

<script>
    import Vue3EasyDataTable from "vue3-easy-data-table";
    import { useJobEntryStore } from '../../../../../stores/ProjectManagement/JobEntry';
    import { mapWritableState } from 'pinia';
    import axios from "axios";

    export default {
        name: "PartsWindow",
        components: {
            Vue3EasyDataTable
        },
        computed: {
            ...mapWritableState(useJobEntryStore, {
                selectedParts: "selectedParts",
            }),
        },
        watch: {},
        mounted() {
            this.fetchPartsTableData();
        },
        data() {
            return {
                search: {
                    columns: ["PartNum"],
                    value: ""
                },
                headers: [
                    { text: "Part", value: "PartNum", sortable: true, width: 250 },
                    { text: "Description", value: "PartDescription", sortable: true },
                    { text: "Class", value: "ClassID", sortable: true }
                ],
                parts: [],
                loading: false
            }
        },
        methods: {
            async fetchPartsTableData() {
                this.loading = true;

                await axios
                    .get( route("legacy-api.partsIndex", {
                        search: this.search.value
                    }) )
                    .then((response) => {
                        this.parts = response.data;

                        this.loading = false;
                    })
                    .catch((err) => {
                        console.log(err)
                    });
            },
            handleSearchUpdate()
            {
                if (this.search.value) {
                    this.search.value = this.search.value.toUpperCase()
                }
                setTimeout(() => {
                    this.fetchPartsTableData()
                }, 50)
            },
            onClearClicked() {
                this.search = "";
            }
        }
    }
</script>

<style scoped>

</style>
